import React, { useRef, useState, useEffect } from "react";
import styled from "@emotion/styled";

import { setFiles, setLoaded } from "../../redux/slices/main";
import { addFilesToSearch } from "../../redux/slices/search";
import { RootState } from "../../redux/store";

import { Box, Button } from "@mui/material";
import { Add as AddIcon } from "@mui/icons-material";

import { useFileUpload } from "../../utils/fnsRedux";
import { getDocumentsByUUID } from "../../firebase/utils";
import { File } from "../../types/app";
import useAppDispatch from "../../hooks/useAppDispatch";
import useAppSelector from "../../hooks/useAppSelector";

const AddFileButton = styled(Button)`
  margin-top: 15px;
  margin-left: 75px;
  height: 35px;
`;

function SidebarAddFile() {
  const dispatch = useAppDispatch();
  const state = useAppSelector((state: RootState) => state.main);
  const inputFile = useRef<null | HTMLInputElement>(null);
  const handleFileUpload = useFileUpload();

  useEffect(() => {
    getDocumentsByUUID("files").then((documents: File[]) => {
      dispatch(setFiles(documents));
      dispatch(setLoaded());
      documents.forEach((document) => {
        dispatch(
          addFilesToSearch({
            fileId: document.fileUid,
            fileName: document.fileName,
          })
        );
      });
    });
  }, [state.snackbarStatus]);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files) {
      handleFileUpload("file", Array.from(event.target.files));
      inputFile.current!.value = "";
    }
  };
  return (
    <Box>
      <input
        onChange={handleChange}
        type="file"
        accept="application/pdf"
        multiple
        id="file"
        ref={inputFile}
        style={{ display: "none" }}
      />
      <AddFileButton
        variant="contained"
        color="primary"
        onClick={() => inputFile.current?.click()}
      >
        Add File
        <AddIcon />
      </AddFileButton>
    </Box>
  );
}

export default SidebarAddFile;
